interface LogoProps {
  className?: string;
  size?: number;
  title?: string;
}

const YoSushiLogo: React.FC<LogoProps> = ({
  className,
  size = 36,
  title = 'Yo!Sushi',
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 130 130'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    role='img'
    aria-label={title}
  >
    <rect width='130' height='130' rx='22' ry='22' fill='currentColor' />
    <line
      x1='12'
      y1='28'
      x2='35'
      y2='68'
      stroke='white'
      strokeWidth='11'
      strokeLinecap='round'
    />
    <line
      x1='52'
      y1='28'
      x2='35'
      y2='68'
      stroke='white'
      strokeWidth='11'
      strokeLinecap='round'
    />
    <line
      x1='35'
      y1='68'
      x2='22'
      y2='102'
      stroke='white'
      strokeWidth='11'
      strokeLinecap='round'
    />
    <circle
      cx='74'
      cy='58'
      r='22'
      stroke='white'
      strokeWidth='11'
      fill='none'
    />
    <rect x='109.5' y='28' width='11' height='48' rx='5.5' fill='white' />
    <circle cx='115' cy='96' r='6.5' fill='white' />
  </svg>
);

export default YoSushiLogo;
